<template>
	<div class="position">
		<div>
			<h3 class="popup-tilte">A kockázatviselés kezdeti dátuma nem megfelelő!</h3>
			<div class="fs-desc popup-content-width">
                Legkorábbi időpont az ajánlattételt követő nap és legkésőbbi időpont az ajánlattételt követő 60. nap.
                Amennyiben jelenleg is van biztosítás az ingatlanon, akkor a fent megadott felmondási időpontot követő nap.
			</div>
            <div class="mt-30px">
                <CalcElem
                    name="start_of_risk"
                    :options="{
                        label: 'Kockázatviselés kezdete',
                        type: 'date',
                        className: 'mw-500px mr-auto d-table',
                        wrapperClass: '',
                        inputClass: 'w-50 mw-500px mobile-width-full',
                        inputGroup: 'calculation',
                        rules: 'required|date_between:now,+60',
                        max: '60',
                        min: '1',
                        fromDateAttr: 'questionAnswers.startOfRisk',
                        tooltip: true,
                        tooltipText: 'Legkorábbi időpont az ajánlattételt követő nap és legkésőbbi időpont az ajánlattételt követő 60. nap. Amennyiben jelenleg is van biztosítás az ingatlanon, akkor a fent megadott felmondási időpontot követő nap.'
                    }"
                />
            </div>
            <div>
                <LoadingButton
					class="btn btn-blue m-auto mt-45px"
					text="Mentés"
					:disabled="!isAfter"
					@click="save"
					:loading="loading"
				/>
            </div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import LoadingButton from '@/components/elements/LoadingButton';

export default {
    components: {
		LoadingButton,
	},
    data() {
        return {
            loading: false
        }
    },
    mounted() {
        this.popupHasClose(false);
    },
    destroyed() {
        this.popupHasClose(true);
    },
    computed: {
        ...mapGetters(['getCalculation']),
        isAfter() {
            return moment(this.getCalculation.start_of_risk).isSameOrAfter(moment().add(1, 'd').format('yyyy-MM-DD'));
        }
    },
    methods: {
        ...mapMutations(['popupHasClose', 'showPopup']),
        ...mapActions(['saveStartOfRisk']),
        async save() {
            this.loading = true;
            await this.saveStartOfRisk();
            this.loading = false;
            this.$parent.resolve();
        }
    }
};
</script>
